"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _signalAnalytics = require("./signalAnalytics");
Object.keys(_signalAnalytics).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _signalAnalytics[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _signalAnalytics[key];
    }
  });
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
var _useCreateGamificationActivity = require("./useCreateGamificationActivity");
Object.keys(_useCreateGamificationActivity).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useCreateGamificationActivity[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useCreateGamificationActivity[key];
    }
  });
});
var _useGetAtpClusterId = require("./useGetAtpClusterId");
Object.keys(_useGetAtpClusterId).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetAtpClusterId[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useGetAtpClusterId[key];
    }
  });
});
var _useGetCustomerInfo = require("./useGetCustomerInfo");
Object.keys(_useGetCustomerInfo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetCustomerInfo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useGetCustomerInfo[key];
    }
  });
});
//# sourceMappingURL=index.js.map